export default "__VITE_ASSET__CMyjoYWh__"